import { HttpClient } from '@angular/common/http';
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../../../services/dialog.service';
import { UMPAction, Utils } from '../../../../../utils/utils';


interface group {
    id: string;
    persona: string;
    isDirect: boolean;
    hidden: boolean;
    parentIds: any;
    IsPrimaryRole: boolean

    // Add more properties if needed
}



@Component({
    selector: "addgroupdialogue",
    templateUrl: './addgroupdialogue.component.html',
    styleUrls: ['../edituser.component.less', './addgroupdialogue.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AddGroupDialogue  {
    public userName: string = '';
    userId = ''


    searchString: string = '';
    filteredSearchResults: any[] = [];

    AllGroups = [];
    UserAssignedGroups: group[] = [];
    UserUnAssignedGroups: group[] = [];
    IsDirIndirComponent = false;

    Response_State: number = 0; //0 -> empty , 1 -> correct and not empty ,-1 -> error
    errorResponse: any;
    isCallSucceed: number = 0;
    userPrimaryRole: group | null = null
    primaryRoles: string | undefined 
    selectedIds = new Set<string>(); //selectedIds is the single source of truth for selection.
    allSelected = false;
    enableSelectAll = false;
    showSelectAllCheckbox = false;

    constructor(
        private readonly http: HttpClient
        , public dialogRef: MatDialogRef<AddGroupDialogue>
        , private readonly confimDialog: DialogService
        , private readonly toastrService: ToastrService,
        private readonly route: ActivatedRoute,
        @Inject('BASE_URL') private readonly baseUrl: string,
        @Inject(MAT_DIALOG_DATA) public data: any,

    ) {
        this.route.params.subscribe(
            (params: Params) => {
                this.resetAll();
            });

    }

    
    resetAll() {
        this.userName = '';
        this.userId = ''


        this.searchString = '';
        this.filteredSearchResults = [];

        this.AllGroups = [];
        this.UserAssignedGroups = [];
        this.UserUnAssignedGroups = [];
        this.IsDirIndirComponent = false;
        this.showSelectAllCheckbox = false;

        this.Response_State = 0; //0 -> empty , 1 -> correct and not empty ,-1 -> error
        this.isCallSucceed = 0;

        this.selectedIds = new Set<string>();
        this.confimDialog.tthis = this;

        this.userId = this.data.userId;
        this.AllGroups = this.data.AllGroups;
        this.UserAssignedGroups = this.data.UserAssignedGroups;
        this.UserUnAssignedGroups = this.data.UserUnAssignedGroups;
        this.IsDirIndirComponent = this.data.IsDirIndirComponent ?? false;
        this.enableSelectAll = this.data.enableSelectAll ?? false;
        this.filteredSearchResults = this.UserUnAssignedGroups;
        this.updateRolesResults();
        this.getAssignedPrimaryRole();
        this.refreshShowSelectAll();
    }
    async updateRolesResults() {
        this.filteredSearchResults = this.searchByValue(this.UserUnAssignedGroups, "persona", this.searchString);
        this.refreshShowSelectAll();
    }

    toggleItemSelection(id: string) {
        if (this.selectedIds.has(id)) {
            this.selectedIds.delete(id);
        } else {
            this.selectedIds.add(id);
        }
    }

    toggleSingleItemSelection(id: string) {
        this.selectedIds.clear();
        this.selectedIds.add(id);
    }

    searchByValue(items: any, filterProperty: string, query: string) {
        return items.filter(item => {
            if (query.trim() === '') {
                return true;
            } else {
                return item[filterProperty]?.toLowerCase()?.includes(query.trim().toLowerCase()) ?? false;
            }
        })
    }


    funcNotify() {
        if (this.isCallSucceed === 1) {
            this.toastrService.success(this.data.title + ' request sent succefully !', 'Add ' + this.data.title + ' Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error(this.data.title + ' request not sent succefully !', 'Add ' + this.data.title + ' Request!');
        }
    }

    getUnselectedItems(allList: any, selectedList: any) {

        this.UserUnAssignedGroups = allList.filter(item => !selectedList.some(selectedItem => selectedItem.id === item.id));
        this.updateRolesResults();

    }

    addButtonHandler() {
        if (this.selectedIds.size === 0) {
            return;
        }
        const ids = this.getSelectedValueFromIds().filter(value => value !== 'selectall');
        this.isCallSucceed = 0;
        Utils.httpPostGroupsByType(
            this.http
            , this.baseUrl
            , {
                "Personae": ids,
                "UmpAction": UMPAction.Assign,
                "UmpCategory": this.data.umpCategory,
                "Type": this.data.type
            }
            , this.userId            
            , this
            , function (tthis: AddGroupDialogue, data: any) {
                tthis.funcNotify();
                //defer the callback until the dialog is fully closed (and the CDK has
                //finished restoring the background scroll position); otherwise any
                //dialog opened from within the callback (e.g. the success/result
                //dialog) gets repositioned while the body scroll is still blocked
                //by the MatDialog overlay, causing it to appear out of view.
                tthis.dialogRef.afterClosed().subscribe(() => {
                    if (tthis.data.callback)
                        tthis.data.callback(data);
                });
                tthis.dialogRef.close();
            }
        )
    }
    backButtonHandler(event: any) {
        event.preventDefault();
        this.dialogRef.close();

    }

    getAssignedPrimaryRole() {
        const combinedArray: any[] = [];
        for (const obj of this.UserAssignedGroups) {
            const group = this.data.AllGroups.find(x => x.persona === obj.persona)
            combinedArray.push({ ...obj, isPrimaryRole: group.isPrimaryRole });
        }

        this.userPrimaryRole = combinedArray.find(x => x.isPrimaryRole === true)
        this.primaryRoles = this.data.AllGroups.filter(x => x.isPrimaryRole).map(x => x.persona).join(", ");
        if (this.userPrimaryRole)
            this.filteredSearchResults = this.filteredSearchResults.filter(x => !x.isPrimaryRole)
    }

    hasAdditionalCosts(persona: string) {
        return Utils.hasAdditionalLicenseCost(persona)
    }

    refreshShowSelectAll() {
        this.showSelectAllCheckbox = this.enableSelectAll && this.filteredSearchResults.length > 0
    }

    toggleSelectAll(event: any) {
        this.allSelected = !this.allSelected;
        if (this.allSelected) {
            this.filteredSearchResults.forEach(item => this.selectedIds.add(item.id));
        } else {
            this.filteredSearchResults.forEach(item => this.selectedIds.delete(item.id));
        }
    }

    private getSelectedValueFromIds() {
        return Array.from(this.selectedIds);
    }
}
